export default __webpack_public_path__ + "static/media/idea.4a28798e.svg";